import React from "react";
import classes from "./Button.module.css"
import classNames from 'classnames'
import {translation} from "../../../I18n/i18n";
import Tooltip from "../Tooltip/Tooltip";
import {useMediaQuery} from "react-responsive";

const Element = (props) => {
    let isSmallScreen = useMediaQuery ({
        query: `(max-width: ${ props.smallScreenThreshold ?
            props.smallScreenThreshold : "50rem" })`
    })
    let btnClasses = classNames (classes.btn,
        {[classes.primary]: (props.variant === "primary")},
        {[classes.default]: (props.variant === "default")},
        {[classes.success]: (props.variant === "success")},
        {[classes.danger]: (props.variant === "danger")},
    )
    let button = <button
        id={ props.id ? props.id : props.label }
        className={ btnClasses }
        onClick={ props.actionHandler }
        disabled={ props.isDisabled }
        aria-controls={props.ariaControls}
        aria-haspopup={props.ariaHaspopup}
        style={ props.style }>
        <span>{ isSmallScreen && props.icon ? props.icon
            : props.lang ? translation (props.lang, props.label) : props.label }</span>
    </button>

    return <div>
        { props.isVisible ?
            props.tooltip || props.tooltipInfo ?
                <Tooltip title={ props.tooltipInfo ? props.tooltipInfo : props.tooltip }
                         tooltipinfo={ props.tooltipInfo ? props.tooltipInfo : undefined }>{ button }</Tooltip>
                : <>{ button }</>
            : `` }
    </div>
}

export default Element;
